import './css/index.css';
import './css/converter.css';
import './css/nanumbarungothic.css';
import './css/modal.css';
import RacingGameManager from './js/app';

export default new RacingGameManager().start();
